import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-search-eye-line text-xl text-primary-400"></i>
                </div>
                <span className="text-lg font-semibold font-heading text-background-50">
                  {t('siteName')}
                </span>
              </div>
              <p className="text-sm text-background-50/50 leading-relaxed">
                {t('siteSlogan')}，提供海量番号数据库检索、分类浏览与详细信息查询服务。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footerAbout')}</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  平台优势
                </Link>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  {t('footerContact')}
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{t('navCategories')}</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/quanxin" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  全新番号
                </Link>
                <Link to="/category/remen" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  热门番号
                </Link>
                <Link to="/category/jingdian" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  经典番号
                </Link>
                <Link to="/category/danpian" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  单片推荐
                </Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">法律信息</h4>
              <div className="flex flex-col gap-2">
                <a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  {t('footerTerms')}
                </a>
                <a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">
                  {t('footerPrivacy')}
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              {t('footerCopyright')}
            </p>
            <p className="text-xs text-background-50/40">
              本站内容仅供学习交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}